module.exports = __webpack_public_path__ + "img/aqt-zr.0d5baf81.png";